export default "__VITE_ASSET__IRkTK0iQ__"